import React, { useState, useEffect } from 'react';
import { getAllQc, CreateCatalogsQs, UpdateCatalogsQc, DeleteCatalogsQc } from '../../services/qualityControl/qualityControl';
import { useForm } from '../forms/useForm';
import * as XLSX from "xlsx-js-style";



export const useQualityControL = () => {

    // * REPORT 
    const [newInfo, setNewInfo] = useState([])


    // * STATE
    const [listQuality, setListQuality] = useState([]);
    const [loading, setLoading] = useState(false)
    const [visible, setVisible] = useState(false);
    const [method, setMethod] = useState("");
    const [tittleDialog, setTittleDialog] = useState("")

    // *  FORM
    const [formValues, handleInputChange, reset, handleUpdateValues] = useForm({
        id_qc_reasons: 0,
        quality_controL: "",
    });

    const [validaciones, setValidaciones] = useState({
        quality_controL: false,
    });

    // * FILTER
    const [globalFilter, setGlobalFilter] = useState("");


    // * ALERTS
    const [showToast, setShowToast] = useState(false);
    const [toastType, setToastType] = useState("info");
    const [toastTitle, setToastTitle] = useState("");
    const [toastMessage, setToastMessage] = useState("");

    const showToastAlert = (
        type = "info",
        title = "",
        message = ""
    ) => {

        setToastType(type);
        setToastTitle(title);
        setToastMessage(message);
        setShowToast(true);
    };

    const closeToastAlert = () => {
        setShowToast(false);
        setToastTitle("");
        setToastMessage("");
    };



    // * EFFECTS
    useEffect(() => {
        getQuality()
    }, [])



    // * VALIDATIONS
    const validarForm = () => {
        let statusValidacion = false;
        let newValidaciones = {};

        if (formValues?.quality_controL.trim().length <= 2) {
            newValidaciones.quality_controL = true;
            statusValidacion = true;
        } else {
            newValidaciones.quality_controL = false;
        }

        setValidaciones(prev => ({
            ...prev,
            ...newValidaciones
        }));

        return statusValidacion;
    };



    // * LIST QUALITY
    const getQuality = async () => {

        setLoading(true);
        const data = await getAllQc();

        if (data?.code === 200) {
            setListQuality(data?.data ?? []);
            setLoading(false);
        }
        else {
            setListQuality([]);
            setLoading(false);
        }
    };


    // * CREATE
    const handleCreate = () => {

        handleUpdateValues({
            id_qc_reasons: 0,
            quality_controL: "",
        });

        setValidaciones({
            quality_controL: false,
        });

        setMethod("create");
        setVisible(true);
        setTittleDialog("Crear control de calidad");
    };

    const saveCreateCharacteristic = async () => {

        if (validarForm()) {
            return;
        }

        setLoading(true);

        try {

            const response = await CreateCatalogsQs({
                quality_controL: formValues.quality_controL.trim(),
            });

            if (response?.code === 200) {
                showToastAlert(
                    "success",
                    "Éxito",
                    "Se creo correctamente el motivo."
                );

                setVisible(false);
                handleUpdateValues({
                    id_qc_reasons: 0,
                    quality_controL: "",
                });

                await getQuality();
            }
            else {
                setVisible(false);
                showToastAlert(
                    "danger",
                    "Catálogo",
                    response?.msg || "Ocurrio un problema al querer generar un nuevo indicador"
                );
            }
        }
        finally {
            setLoading(false);
        }
    };


    // * UPDATE
    const handleUpdate = (_search) => {

        handleUpdateValues({
            id_qc_reasons: _search.id_qc_reasons,
            quality_controL: _search.quality_controL,
        });

        setValidaciones({
            quality_controL: false,
        });

        setMethod("update");
        setVisible(true);
        setTittleDialog("Actualizar control de calidad");
    };


    const saveUpdateCharacteristic = async () => {

        if (validarForm()) {
            return;
        }

        setLoading(true);

        try {

            const response = await UpdateCatalogsQc({
                id_qc_reasons: formValues?.id_qc_reasons,
                quality_controL: formValues?.quality_controL.trim(),
            });

            if (response?.code === 200) {

                setVisible(false);
                showToastAlert(
                    "success",
                    "Éxito",
                    "Se actualizo correctamente el motivo."
                );

                handleUpdateValues({
                    id_qc_reasons: 0,
                    quality_controL: "",
                });

                await getQuality();
            }
            else {
                setVisible(false);
                showToastAlert(
                    "danger",
                    "Catálogo",
                    response?.msg || "Ocurrio un problema al querer actualizar un nuevo indicador"
                );
            }

        }
        finally {
            setLoading(false);
        }
    };



    // * DELETE
    const handleDelete = async (_find) => {

        handleUpdateValues({
            id_qc_reasons: _find?.id_qc_reasons,
            quality_controL: _find?.quality_controL,
        });
        setMethod("delete");
        setVisible(true);
        setTittleDialog("Eliminar control de calidad")
    };


    const saveDelete = async () => {

        setVisible(true);

        const result = await DeleteCatalogsQc({
            id_qc_reasons: formValues?.id_qc_reasons
        });

        if (result?.code === 200) {
            setVisible(false);
            showToastAlert(
                "success",
                "Éxito",
                "Se elimino correctamente el motivo."
            );

            handleUpdateValues({
                id_qc_reasons: 0,
                quality_controL: "",
            });

            await getQuality();
        } else {
            setVisible(false);
            showToastAlert(
                "danger",
                "Catálogo",
                result?.msg || "Ocurrio un problema al querer eliminar un nuevo indicador"
            );
        }
    }


    // * REPORT

    const exportExcel = () => {

        if (!listQuality || listQuality.length === 0) {
            showToastAlert(
                "warning",
                "Catálogo de Control y Calidad",
                "No hay un indicador, por lo tanto no se podrá generar el reporte."
            );
            return;
        }

        const exportData = listQuality.map((_qc, index) => {
            return {
                "#": index + 1,
                "Indicador de control de calidad":
                    _qc?.quality_controL || "",
            };
        });


        const worksheet =
            XLSX.utils.json_to_sheet(exportData);




        ["A1", "B1"].forEach((cellAddress) => {

            if (worksheet[cellAddress]) {

                worksheet[cellAddress].s = {

                    fill: {
                        patternType: "solid",
                        fgColor: {
                            rgb: "1B658B"
                        }
                    },

                    font: {
                        color: {
                            rgb: "FFFFFF"
                        },
                        bold: true
                    },

                    alignment: {
                        horizontal: "center",
                        vertical: "center"
                    },

                    border: {
                        top: {
                            style: "thin",
                            color: {
                                rgb: "D9E2E8"
                            }
                        },
                        bottom: {
                            style: "thin",
                            color: {
                                rgb: "D9E2E8"
                            }
                        },
                        left: {
                            style: "thin",
                            color: {
                                rgb: "D9E2E8"
                            }
                        },
                        right: {
                            style: "thin",
                            color: {
                                rgb: "D9E2E8"
                            }
                        }
                    }
                };
            }
        });



        listQuality.forEach((_, index) => {

            const cellAddress = `A${index + 2}`;

            if (worksheet[cellAddress]) {

                worksheet[cellAddress].s = {

                    fill: {
                        patternType: "solid",
                        fgColor: {
                            rgb: "1B658B"
                        }
                    },

                    font: {
                        color: {
                            rgb: "FFFFFF"
                        },
                        bold: true
                    },

                    alignment: {
                        horizontal: "center",
                        vertical: "center"
                    },

                    border: {
                        top: {
                            style: "thin",
                            color: {
                                rgb: "D9E2E8"
                            }
                        },
                        bottom: {
                            style: "thin",
                            color: {
                                rgb: "D9E2E8"
                            }
                        },
                        left: {
                            style: "thin",
                            color: {
                                rgb: "D9E2E8"
                            }
                        },
                        right: {
                            style: "thin",
                            color: {
                                rgb: "D9E2E8"
                            }
                        }
                    }
                };
            }
        });



        worksheet["!cols"] = [
            {
                wch: 8
            },
            {
                wch: 70
            }
        ];




        const workbook =
            XLSX.utils.book_new();


        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Catálogo control calidad"
        );



        const excelBuffer =
            XLSX.write(
                workbook,
                {
                    bookType: "xlsx",
                    type: "array"
                }
            );


        const dataBlob =
            new Blob(
                [excelBuffer],
                {
                    type:
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                }
            );



        const fileName =
            "Catálogo de control de calidad.xlsx";



        const url =
            window.URL.createObjectURL(dataBlob);


        const link =
            document.createElement("a");


        link.href = url;

        link.download =
            fileName;


        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);


        window.URL.revokeObjectURL(url);
    };


    // * FILTERS
    const filterData = (data, filter) => {

        if (!filter?.trim()) {
            return data;
        }

        const search = filter.toLowerCase().trim();

        return data.filter(row => {

            const qualityControl = row?.quality_controL?.toLowerCase() ?? "";

            return qualityControl.includes(search);
        });
    };




    return {

        // ? CRUD
        listQuality,
        handleCreate,
        saveCreateCharacteristic,
        saveUpdateCharacteristic,
        handleUpdate,
        handleDelete,
        formValues,
        handleInputChange,
        validaciones,
        saveDelete,
        exportExcel,


        // ? DIALOG
        loading,
        visible,
        method,
        setVisible,
        tittleDialog,


        // ? ALERTS
        showToast,
        toastType,
        toastTitle,
        toastMessage,
        closeToastAlert,


        // ? FILTERS
        globalFilter,
        setGlobalFilter,
        filterData


    }
}

